export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./PageDivider.vue?vue&type=template&id=f23130be&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/PageDivider.vue?vue&type=template&id=f23130be&scoped=true&
// module id = 126
// module chunks = 0